type Environment =
  | 'main'
  | 'production'
  | 'staging'
  | 'uat'
  | 'stable'
  | 'dev'
  | 'local';

export const getCurrentEnvironment = (): Environment => {
  if (typeof window !== 'undefined') {
    const origin: string = (window as any)?.location?.origin || '';
    if (origin.includes('ims.ufa.com.lb')) {
      return 'main';
    }
    if (origin.includes('staging')) {
      return 'staging';
    } else if (origin.includes('redbridge-ui.lemonriver')) {
      return 'production';
    } else if (origin.includes('uat')) {
      return 'uat';
    } else if (origin.includes('stable')) {
      return 'stable';
    } else if (origin.includes('dev')) {
      return 'dev';
    }
  } else {
    return 'uat';
  }

  return 'stable';
};

export interface IEnviromentData {
  graphBaseUrl: string;
  mainHostUrl: string;
  identityBaseUrl: string;
  identityRedirectUrl: string;
}

export const getEnviromentDetails = (): IEnviromentData => {
  const currentEnv = getCurrentEnvironment();

  switch (currentEnv) {
    case 'main': {
      return {
        graphBaseUrl: 'https://ufapos-api.ufa.com.lb',
        mainHostUrl: 'https://ims.ufa.com.lb',
        identityBaseUrl: 'https://ufapos-id.ufa.com.lb',
        identityRedirectUrl: `https://ims.ufa.com.lb/connect/token`
      };
    }
    case 'staging': {
      return {
        graphBaseUrl: 'https://tms-api-staging.baibars.club',
        mainHostUrl: 'https://tms-staging.baibars.club',
        identityBaseUrl: 'https://tms-id-staging.baibars.club',
        identityRedirectUrl: `https://tms-staging.baibars.club/connect/token`
      };
    }
    case 'production': {
      return {
        graphBaseUrl:
          'https://redbridge-api-prod-bre0hjd5brg4bsej.francecentral-01.azurewebsites.net',
        mainHostUrl:
          'https://redbridge-ui.lemonriver-35ea857d.westus2.azurecontainerapps.io',
        identityBaseUrl:
          'https://redbridge-id-prod-g0a7f7cneeb3chbu.francecentral-01.azurewebsites.net',
        identityRedirectUrl: `https://redbridge-ui.lemonriver-35ea857d.westus2.azurecontainerapps.io/connect/token`
      };
    }
    case 'uat': {
      return {
        graphBaseUrl: 'https://tms-api-uat.baibars.club',
        mainHostUrl: 'https://tms-uat.baibars.club',
        identityBaseUrl: 'https://tms-id-uat.baibars.club',
        identityRedirectUrl: `https://tms-uat.baibars.club/connect/token`
      };
    }
    case 'stable': {
      return {
        graphBaseUrl: 'https://tms-api-stable.baibars.club',
        mainHostUrl: 'https://tms-stable.baibars.club',
        identityBaseUrl: 'https://tms-id-stable.baibars.club',
        identityRedirectUrl: `https://tms-stable.baibars.club/connect/token`
      };
    }
    case 'dev': {
      return {
        graphBaseUrl: 'https://tms-api-dev.baibars.club',
        mainHostUrl: 'https://tms-dev.baibars.club',
        identityBaseUrl: 'https://tms-id-dev.baibars.club',
        identityRedirectUrl: `https://tms-dev.baibars.club/connect/token`
      };
    }
    case 'local': {
      return {
        graphBaseUrl: 'https://localhost:7096',
        mainHostUrl: 'https://tms-stable.baibars.club',
        identityBaseUrl: 'https://tms-id-stable.baibars.club',
        identityRedirectUrl: `https://tms-stable.baibars.club/connect/token`
      };
    }
    default: {
      return {
        graphBaseUrl: 'https://tms-api-dev.baibars.club',
        mainHostUrl: 'https://tms-dev.baibars.club',
        identityBaseUrl: 'https://tms-id-dev.baibars.club',
        identityRedirectUrl: `https://tms-dev.baibars.club/connect/token`
      };
    }
  }
};

export const isProd = () => {
  const origin: string = (window as any)?.location?.origin || '';

  return origin.includes('ims.ufa.com.lb');
};

export const TinyMCEApiKey = '1zpxcry8s9a6chrmtwzhr9g4fpr8m1fywjo4eq76vdj33per';
